// Structured-data factories. All URLs use the production canonical domain.
import { IMAGES } from "../../content/images";

const SITE_URL = "https://quscap.com";
const SITE_NAME = "Quantum US Capital Partners LLC";

export function organizationLd() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    legalName: SITE_NAME,
    alternateName: "Quantum US Capital Partners",
    url: SITE_URL,
    logo: IMAGES.home_hero_promenade,
    description:
      "A privately held investment institution. Long-term capital across industrials, infrastructure, energy, and manufacturing.",
    slogan: "The Art of Capital",
    foundingLocation: { "@type": "Country", name: "United States" },
    areaServed: ["United States", "Europe", "Middle East"],
    sameAs: [],
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "investor relations",
        email: "chairman@quscap.com",
        availableLanguage: ["English"],
      },
    ],
  };
}

export function websiteLd() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: SITE_URL,
    inLanguage: "en-US",
    description:
      "A privately held investment institution. Long-term capital across industrials, infrastructure, energy, and manufacturing.",
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      url: SITE_URL,
    },
  };
}

export function articleLd({ slug, title, dateline, excerpt, image }) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description: excerpt,
    image: image ? [image] : undefined,
    datePublished: dateline,
    inLanguage: "en-US",
    isPartOf: {
      "@type": "Series",
      name: "Quantum Letters",
    },
    author: {
      "@type": "Organization",
      name: SITE_NAME,
      url: SITE_URL,
    },
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      url: SITE_URL,
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${SITE_URL}/letters/${slug}`,
    },
  };
}
